import { Add } from '@mui/icons-material';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
} from '@mui/material';
import {
  DataGrid,
  deDE,
  GridColDef,
  GridRowSelectionModel,
  GridValueGetterParams,
} from '@mui/x-data-grid';
import React, { useState } from 'react';
import { ILegalClient } from '../Interfaces/ILegalClient';
import { LoadingDialog } from '../core/LoadingDialog';

const columns: GridColDef[] = [
  { field: 'idLegalClient', headerName: 'Nr.', width: 90 },
  { field: 'LegalClientType', headerName: 'Typ', width: 150 },
  {
    field: 'idLegalClientType',
    headerName: 'Name',
    flex: 1,
    valueGetter: (params: GridValueGetterParams) =>
      Number(params.value) === 1
        ? `${params.row.FirstName} ${params.row.LastName}`
        : params.row.FirstName,
  },
  { field: 'Email', headerName: 'E-Mail', flex: 1 },
];

interface IProps {
  blockedIds: number[];
  selectedIds: number[];
  setSelected: (selectedLegalClient: ILegalClient[]) => void;
  allLegalClients: ILegalClient[];
  unmount: () => void;
}

export const LegalClientSelectDialog: React.FC<IProps> = ({
  blockedIds,
  selectedIds,
  setSelected,
  allLegalClients,
  unmount,
}) => {
  const [isAddPending, setIsAddPending] = useState(false);
  const [search, setSearch] = useState('');
  const [rowSelectionModel, setRowSelectionModel] =
    useState<GridRowSelectionModel>(selectedIds);

  const lowerSearchTerm = search.toLowerCase();

  const filteredContacts = allLegalClients.filter(lc => {
    if (!search) {
      return true;
    } else {
      return (
        (lc.FirstName &&
          lc.FirstName.toLowerCase().includes(lowerSearchTerm)) ||
        (lc.LastName && lc.LastName.toLowerCase().includes(lowerSearchTerm)) ||
        (lc.Email && lc.Email.toLowerCase().includes(lowerSearchTerm))
      );
    }
  });

  const onAdd = () => {
    setIsAddPending(true);

    const selectedContacts = allLegalClients.filter(lc =>
      rowSelectionModel.includes(lc.idLegalClient)
    );
    setSelected([...selectedContacts]);
    setIsAddPending(false);
    unmount();
  };

  if (isAddPending) return <LoadingDialog unmount={() => {}} />;

  return (
    <>
      <Dialog maxWidth='md' fullWidth open onClose={unmount}>
        <DialogTitle>Mandant wählen</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex' }}>
            <TextField
              size='small'
              sx={{ mt: 2 }}
              label='Suche'
              value={search}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setSearch(event.target.value)
              }
              fullWidth
            />
            <IconButton sx={{ float: 'right', mt: 1, ml: 2 }} disabled>
              <Add />
            </IconButton>
          </Box>
          <DataGrid
            sx={{ mt: 2 }}
            autoHeight
            checkboxSelection
            localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
            rows={filteredContacts}
            onRowSelectionModelChange={newRowSelectionModel => {
              if (search === '') {
                setRowSelectionModel(Array.from(new Set(newRowSelectionModel)));
              } else {
                const filteredSelection = rowSelectionModel.filter(
                  id =>
                    !filteredContacts.some(
                      contact => contact.idLegalClient === id
                    )
                );
                const updatedSelection = [
                  ...filteredSelection,
                  ...newRowSelectionModel,
                ];
                setRowSelectionModel(Array.from(new Set(updatedSelection)));
              }
            }}
            rowSelectionModel={rowSelectionModel}
            columns={columns}
            getRowId={row => row.idLegalClient}
            isRowSelectable={params =>
              !blockedIds.includes(params.row.idLegalClient)
            }
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 15,
                },
              },
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={unmount} variant='outlined'>
            Abbrechen
          </Button>
          <Button
            variant='contained'
            disabled={rowSelectionModel.length === 0}
            onClick={onAdd}
          >
            Übernehmen
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
